import { SWAP_DEPOSIT_TOKENS } from '@kwenta/sdk/constants'
import { SwapDepositToken } from '@kwenta/sdk/types'
import { FC, useCallback } from 'react'

import { AssetSelector } from 'components/Input/InputWithAssetSelector'
import { setPreferences } from 'state/futures/reducer'
import { selectSelectedSwapDepositToken } from 'state/futures/snxPerpsV2/selectors'
import { useAppDispatch, useAppSelector } from 'state/hooks'

type SwapDepositTokenSelectorProps = {
	small?: boolean
}

const SwapDepositTokenSelector: FC<SwapDepositTokenSelectorProps> = ({ small = true }) => {
	const dispatch = useAppDispatch()
	const selectedToken = useAppSelector(selectSelectedSwapDepositToken)

	const handleTokenSelect = useCallback(
		(token: string) => {
			dispatch(setPreferences({ selectedSwapDepositToken: token as SwapDepositToken }))
		},
		[dispatch]
	)

	return (
		<AssetSelector
			small={small}
			assets={SWAP_DEPOSIT_TOKENS}
			selectedAsset={selectedToken}
			onSelectAsset={handleTokenSelect}
		/>
	)
}

export default SwapDepositTokenSelector
